import React from 'react';
export const FeatureFlagConfigChangeContext = React.createContext({
    configKey: Date.now(),
    onConfigChanged: () => { },
});
